import script from "./AwesomeOscillator.vue?vue&type=script&lang=js"
export * from "./AwesomeOscillator.vue?vue&type=script&lang=js"

const __exports__ = script;

export default __exports__